<template>
  <div
    :class="{ 'loader--global': global }"
    class="loader">
    <div class="loader__content">
      <transition
        name="fade"
        mode="out-in">
        <img
          v-show="!timeout"
          src="../../assets/img/spinner.svg"
          alt>
      </transition>
      <transition
        name="fade"
        mode="out-in">
        <span
          v-for="(message, index) in messages"
          v-if="wait === index"
          :key="index">
          {{ message }}
        </span>
        <span
          v-if="timeout"
          key="last">
          Something must have broken.
          <a
            href=""
            @click="reload">
            Reload
          </a>
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    global: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      interval: null,
      wait: 0,
      messages: [
        'Please wait',
        'Sorry, just a little longer',
        'Things are moving a little slowly',
      ],
    };
  },
  computed: {
    timeout() {
      return this.wait === this.messages.length;
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.timeout) {
        clearInterval(this.interval);
        return;
      }
      this.wait += 1;
    }, 3500);
  },
  methods: {
    reload() {
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  align-items: center;
  background: rgba(#fff, .6);
  bottom: 0;
  color: $color-red;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 9;

  img {
    display: block;
    margin: 0 auto 20px;
  }
}
.loader--global {
  background: rgba(#fff, .9);
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Loader.vue